import { Component, type ErrorInfo, type ReactNode } from 'react';
import { StatusBanner } from './StatusBanner';

interface Props {
  children: ReactNode;
  fallback?: (error: Error) => ReactNode;
}
interface State { error: Error | null }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };
  static getDerivedStateFromError(error: Error): State { return { error }; }
  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info);
  }
  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    if (this.props.fallback) return this.props.fallback(error);
    return (
      <StatusBanner tone="error" title="Something went wrong">
        <pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>{error.message}</pre>
      </StatusBanner>
    );
  }
}
